import useFunctionContext from './internal/useFunctionContext';
export default function useScrollToEnd() {
  var _useFunctionContext = useFunctionContext(),
      scrollToEnd = _useFunctionContext.scrollToEnd;

  return scrollToEnd;
}